import $ from 'jquery';

export default () => {
  const menus = $('#header').add('.region-mobile').find('.block-menu .menu');
  const headers = menus.find('.level--1');

  headers.click(function(event) {
    const header = $(this);

    menus.find('.sub').removeClass('sub--open');

    if (header.hasClass('expand')) {
      header.removeClass('expand');
    } else {
      menus.find('.sub').removeClass('sub--open');
      headers.removeClass('expand');

      header.addClass('expand')
        .find('.sub').addClass('sub--open');
    }
  });

  $(document).click(function(event) {
    const header = headers.filter('.expand');
    const menu = header.closest('.block-menu');

    if (menu.find(event.target).length === 0) {
      headers.removeClass('expand');
      menus.find('.sub').removeClass('sub--open');
    }
  });
}
